import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'

import classNames from 'classnames'

import classes from './SettingsForm.module.scss'
import { deleteUser } from '../../../actions/userActions'
import SubmitButton from '../../common/buttons/SubmitButton'
import DeleteAccountModal from './DeleteAccountModal'
import { AccountContext } from '../AccountContext'
import { useContext } from 'react'

const SettingsForm = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user, submitDisabled } = useContext(AccountContext) // Note: user could be golfer OR current_user
  const currentUser = useSelector(state => state.user.current_user)

  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false)
  const [password, setPassword] = useState('')
  const [passwordError, setPasswordError] = useState('')

  const isOwnAccount = currentUser.id === user.id

  const handleDeleteAccount = () => {
    dispatch(deleteUser(user.id, password))
      .then((response) => {
        if (isOwnAccount) {
          const logoutUrl = response?.data?.logout_url
          window.location.href = logoutUrl
            ? `${logoutUrl}${process.env.REACT_APP_BASE_URL}/post-logout`
            : '/post-logout'
        } else {
          navigate('/dashboard/account')
        }
      })
      .catch((error) => {
        if (error.response?.status === 503) {
          setPasswordError(t('account.settings.deleteUnavailable'))
        } else if (error.response && error.response.data?.errors?.current_password) {
          setPasswordError(
            isOwnAccount
              ? t('account.settings.passwordIncorrect')
              : t('account.settings.passwordIncorrectJunior')
          )
        } else {
          setPasswordError(t('common.somethingWentWrong'))
        }
      })
  }

  const renderResetPasswordSection = () => {
    if (user.type === 'Coach') {
      return (
        <div>
          <p>{t('account.settings.dataDeletionIntro')}</p>
          <p>
            <Trans
              i18nKey='account.settings.dataDeletionInstructions'
              components={{ b: <span className='font-weight-bold' /> }}
            />
          </p>
          <a className='btn btn-primary text-white' href='mailto:support@op36golf.com'>{t('account.settings.contactUs')}</a>
        </div>
      )
    }

    if (currentUser.family_admin) {
      if (!isOwnAccount && user.family_admin) {
        return <p className={classes.deleteMessage}>{t('account.settings.cannotDeleteFamilyAdmin')}</p>
      }

      return (
        <div className='d-flex flex-column'>
          <p className={classes.deleteMessage}>{t('account.settings.confirmDelete')}</p>

          <SubmitButton
            onClick={(e) => { e.preventDefault(); setShowDeleteAccountModal(true) }}
            buttonMessage={t('account.common.deleteAccount')}
            buttonColor='orange-button'
            className={classNames(classes.deleteButton, 'mt-auto')}
            disabled={submitDisabled}
          />

          <DeleteAccountModal
            user={user}
            isOwnAccount={isOwnAccount}
            showModal={showDeleteAccountModal}
            closeModal={() => { setPassword(''); setPasswordError(''); setShowDeleteAccountModal(false) }}
            password={password}
            passwordError={passwordError}
            handlePasswordChange={(e) => { setPassword(e.target.value) }}
            handleDeleteAccount={handleDeleteAccount}
          />
        </div>
      )
    }

    return <p className={classes.deleteMessage}>{t('account.settings.onlyFamilyAdminsCanDelete')}</p>
  }

  return (
    <div className={classNames(classes.accountSettings, 'animated fadeIn d-flex flex-column')}>
      <div className='row'>
        <h4 className={classNames(classes.title, 'col-md-12 p-0')}>{t('account.common.accountSettings')}</h4>
        <p className={classNames(classes.deleteSubtitle, 'p-0 pb-2')}>{t('account.settings.deleteSubtitle')}</p>
      </div>
      <div className='row p-0'>
        {renderResetPasswordSection()}
      </div>
    </div>
  )
}

export default SettingsForm
